//TODO: vite node polyfill doesnt work,  this is a workaround do not remove
import { Buffer } from "buffer";
import Process from "process";
//@ts-ignore
globalThis.Buffer = Buffer;
globalThis.process = Process;